/* unplugin-vue-components disabled */import { render } from "./templateDemeRadio.vue?vue&type=template&id=74f38122&scoped=true"
import script from "./templateDemeRadio.vue?vue&type=script&lang=js"
export * from "./templateDemeRadio.vue?vue&type=script&lang=js"

import "./templateDemeRadio.vue?vue&type=style&index=0&id=74f38122&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f38122"]])

export default __exports__